import {Select} from '@hconnect/common/components'
import {ControlledFormField, FormFieldBase, SelectOption} from '@hconnect/common/types'
import {Controller, FieldValues} from 'react-hook-form'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {OilAnalysisActionPriority} from '../../types'

type Props<TField extends FieldValues> = FormFieldBase &
  ControlledFormField<TField> & {
    onChange?: (value: OilAnalysisActionPriority | undefined) => void
  }

export const OilAnalysisPriorityField = <TField extends FieldValues>(props: Props<TField>) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const options: SelectOption<OilAnalysisActionPriority>[] = Object.values(
    OilAnalysisActionPriority
  ).map((priority) => ({
    value: priority,
    label: t(`oilAnalysisActions.priority.${priority}`)
  }))

  return (
    <Controller
      name={props.name}
      control={props.control}
      disabled={props.disabled || props.readOnly}
      render={({field, fieldState}) => (
        <Select
          data-test-id={`select-field-${field.name}`}
          name={field.name}
          options={options}
          label={props.label}
          value={field.value}
          onChange={(value) => {
            field.onChange(value)
            props.onChange?.(value)
          }}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          disabled={props.disabled}
          required={props.required}
          optional={props.optional}
          readOnly={props.readOnly}
        />
      )}
    />
  )
}
